import Image from 'next/image';
import type { IntlShape } from 'react-intl';
import Heading from '@alltrails/denali/components/Heading';
import leaveNoTraceSrc from './leave-no-trace.svg';
import onePercentForThePlanetSrc from './one-percent-for-the-planet.svg';
import styles from './styles.module.scss';

type Props = {
  intl: IntlShape;
};

const MembersForThePlanet = ({ intl }: Props) => (
  <div className={styles.container}>
    <Heading as="h2" className={styles.title} size="300">
      {intl.formatMessage({ defaultMessage: 'Members for the planet' })}
    </Heading>
    <div className={styles.membersIconsContainer}>
      <Image
        alt="1% for the Planet"
        className={styles.logo}
        height={36}
        src={onePercentForThePlanetSrc}
        width={86}
      />
      <Image alt="Leave No Trace" className={styles.logo} height={36} src={leaveNoTraceSrc} width={76} />
    </div>
  </div>
);

export default MembersForThePlanet;
